export function formatNumber(value: number | null) {
  let realValue: string | number = 0
  if (value && typeof value === 'number') {
    realValue = Number.isInteger(value) ? value : value.toFixed(3)
  }
  return realValue
}
